module.exports = __webpack_public_path__ + "static/media/home-img.0e3a8e04.jpg";